var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Link } from "react-router-dom";
import { Header, Icon, Table } from "semantic-ui-react";
import { AppPaths } from "../AppConfig";
var inventoryPageLinks = [
    {
        title: "Fluorescent Hairpin Inventory",
        description: "Track fluorescent hairpin inventory.",
        path: AppPaths.ADMIN_FLUORESCENT_HAIRPIN_TRACKING
    },
    {
        title: "Manual Buffer Inventory",
        description: "Track manual buffer inventory.",
        path: AppPaths.ADMIN_MANUAL_BUFFER_TRACKING
    },
    {
        title: "Encoder Inventory",
        description: "Track encoder inventory.",
        path: AppPaths.ADMIN_ENCODER_TRACKING
    },
    {
        title: "Secondary IF Probe Inventory",
        description: "Track secondary IF probe inventory.",
        path: AppPaths.ADMIN_SECONDARY_IF_PROBE_TRACKING
    }
];
var InventoryPage = /** @class */ (function (_super) {
    __extends(InventoryPage, _super);
    function InventoryPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InventoryPage.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Header, null, "Inventory"),
            React.createElement("div", { id: "non-header-portion" },
                React.createElement(Table, { striped: true, celled: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Inventory Page"),
                            React.createElement(Table.HeaderCell, null, "Description"),
                            React.createElement(Table.HeaderCell, null, "Open"))),
                    React.createElement(Table.Body, null, inventoryPageLinks.map(function (inventoryPageLink) { return (React.createElement(Table.Row, { key: inventoryPageLink.path },
                        React.createElement(Table.Cell, null,
                            React.createElement(Link, { to: inventoryPageLink.path }, inventoryPageLink.title)),
                        React.createElement(Table.Cell, null, inventoryPageLink.description),
                        React.createElement(Table.Cell, { collapsing: true },
                            React.createElement(Link, { to: inventoryPageLink.path },
                                React.createElement(Icon, { name: "arrow right" }),
                                "Open")))); }))))));
    };
    return InventoryPage;
}(React.PureComponent));
export default InventoryPage;
//# sourceMappingURL=InventoryPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/InventoryPage.js
// module id = 1476
// module chunks = 0